import createSpinner from "../../../../../Shared/Functions/createSpinner";
import { standardGridPageSize } from "../../../../../Shared/GlobalVariables/filterVariables";
import sourceEntitySettingsModalController from "./sourceEntitySettingsModal.controller";

export default /*@ngInject*/ function (connectionsDataService, helperService, $uibModal) {
    const vm = this;

    vm.$onInit = init;
    vm.$onChanges = navigateForm;
    vm.click = click;
    vm.helperService = helperService;
    vm.navigateForm = navigateForm;
    vm.getSourceMetadata = getSourceMetadata;
    vm.importSourceMetadata = importSourceMetadata;
    vm.sourceEntitiesToUpdate = sourceEntitiesToUpdate;
    vm.openEntitySettingsModal = openEntitySettingsModal;

    const keys = ['metadataImported'];

    vm.verifyConnectionSettings = false;
    vm.allEntityFieldsList = [];

    async function init() {
        vm.product.metadataImported = null;
        vm.product.SourceEntitiesToUpdate = vm.product?.SourceEntitiesToUpdate ? vm.product.SourceEntitiesToUpdate : [];

        await getSourceMetadata();

        vm.product.dataMappingsValid = null;
    }

    async function importSourceMetadata(importType) {
        vm.importPending = new createSpinner();
        try {
            vm.importPending.loadingValue = true;
            let formData = new FormData(),
                importTypeString = importType;

            if (importType === 'sql') {
                if (vm.product.DataSource.Name === 'Oracle SQL') {
                    importTypeString = 'oracle-sql';
                }  
            }
            else if (importType === 'rest-api') {
                formData.append('ApiSpecificationDocument', vm.metadataFile.files[0]?.flowObj?.files[0].file);
            }
            else {
                if (vm.metadataFile.files[0]?.flowObj?.files[0].file.type.includes('zip')) {
                    importTypeString = 'csv';
                }

                formData.append(vm.metadataFile.files[0]?.flowObj?.files[0].file.name, vm.metadataFile.files[0]?.flowObj?.files[0].file);
            }

            let response = await connectionsDataService.getSourceMetadata(vm.product.ID, importTypeString, formData);

            vm.product.CustomProductSourceMetadata = response.data;
            vm.existingMetadata = true;

            await getSourceMetadata();
            if (vm.metadataFile) {
                vm.metadataFile.files = [];
            }

            if (response.data.Entities.length) {
                vm.updateHiddenSteps(4, false);
                await setSourceMetadataEntityTabs();
            }

            vm.product.metadataImported = true;
            vm.verifyConnectionSettings = false;
            vm.importPending.loadingValue = false;
        } catch (err) {
            if (err && importType === 'sql') {
                vm.verifyConnectionSettings = true;
            }
            vm.importPending.loadingValue = false;
        }
    }

    async function getSourceMetadata() {
        vm.loading = true;
        try {
            if (vm.product?.ID) {
                let response = await connectionsDataService.getProductById(vm.product.ID);
                vm.product.CustomProductSourceMetadata = response.data.CustomProductSourceMetadata;
                vm.product.DataMappings = vm.product?.mappingsMetadata ? vm.product.DataMappings : response.data.DataMappings;
                vm.product.existingDataMappings = response.data.DataMappings.length > 0 ? true : false;
                vm.existingMetadata = vm.product.CustomProductSourceMetadata?.Entities.length > 0 ? true : false;

                vm.product.CustomProductSourceMetadata.Entities.forEach(entity => {
                    let entityFieldsList = entity.EntityFields.map(field => field);

                    vm.allEntityFieldsList = vm.allEntityFieldsList.concat(entityFieldsList).unique();

                    let matchingEditedSourceEntity = vm.product.SourceEntitiesToUpdate.find(sourceEntity => entity.Id === sourceEntity.Id);
                    if (matchingEditedSourceEntity?.SourceMetadataFieldForLoopLookup) {
                        entity.SourceMetadataFieldIdForLoopLookup = matchingEditedSourceEntity.SourceMetadataFieldForLoopLookup.Id;
                    }
                });

                if (response.data.CustomProductSourceMetadata?.Entities.length) {
                    vm.updateHiddenSteps(4, false);
                    await setSourceMetadataEntityTabs();
                    vm.product.metadataImported = true;
                }
            }
            vm.loading = false;
        } catch {
            vm.loading = false;
        }
    }

    async function setSourceMetadataEntityTabs() {
        if (vm.product.CustomProductSourceMetadata?.Entities) {
            vm.product.CustomProductSourceMetadata.Entities.forEach(entity => {
                entity.active = false;
            });

            vm.currentTabIndex = 0;
            vm.product.CustomProductSourceMetadata.Entities[vm.currentTabIndex].active = true;
            vm.selectedEntityFields = vm.product.CustomProductSourceMetadata.Entities[vm.currentTabIndex].EntityFields;
            await setFieldKeys();
        }
    }

    function setFieldKeys() {
        vm.fieldKeys = Object.keys(vm.selectedEntityFields[0]);
        vm.metadataColumns = [];

        vm.fieldKeys = vm.fieldKeys.filter(key => key !== 'Id');

        vm.fieldKeys.forEach(key => {
            let column = { field: key, title: key, width: 50, filterable: false };

            vm.metadataColumns.push(column);
        });

        vm.sourceMetadataGridOptions = helperService.setMainGridOptions(vm.metadataColumns, 400);
        vm.sourceMetadataGridOptions.autoBind = true;
        vm.sourceMetadataGridOptions.noRecords = {
            template: "<div class='no-data-to-display-message'>No items to display</div>"
        };

        vm.sourceMetadataGridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            transport: {
                read: async options => {
                    try {
                        options.success(vm.selectedEntityFields);
                    } catch {
                        options.error();
                    }
                }
            }
        });
    }

    function sourceEntitiesToUpdate(entity) {
        if (vm.product.SourceEntitiesToUpdate.every(existingEntity => existingEntity.Id !== entity.Id)) {
            vm.product.SourceEntitiesToUpdate.push(entity);
        } else {
            let index = vm.product.SourceEntitiesToUpdate.findIndex((existingEntity => existingEntity.Id !== entity.Id));

            vm.product.SourceEntitiesToUpdate[index] = entity;
        }
    }

    async function openEntitySettingsModal(entity) {
        let entitySettingsModal = $uibModal.open({
            templateUrl: '/App/Components/Connections/CustomProductConnection/DataMapping/ImportMetadata/sourceEntitySettingsModal.tmpl.html',
            controller: sourceEntitySettingsModalController,
            controllerAs: 'sesmvm',
            backdrop: 'static',
            resolve: {
                entity: () => entity || null,
                allEntityFieldsList: () => vm.allEntityFieldsList
            }
        });

        try {
            let result = await entitySettingsModal.result;
            sourceEntitiesToUpdate(result);
        } catch (_) {
            return;
        }
    }

    async function click(tab) {
        const tabIndex = vm.product.CustomProductSourceMetadata.Entities.findIndex(t => t.Id === tab.Id);

        if (vm.currentTabIndex !== tabIndex) {
            vm.product.CustomProductSourceMetadata.Entities[vm.currentTabIndex].active = false;
            vm.currentTabIndex = tabIndex;
            vm.product.CustomProductSourceMetadata.Entities[vm.currentTabIndex].active = true;
        }

        vm.selectedEntityFields = vm.product.CustomProductSourceMetadata.Entities[vm.currentTabIndex].EntityFields;
        await vm.sourceMetadataGridDataSource.read();
    }

    async function navigateForm() {
        const product = vm.product;

        if (vm.product?.metadataFile?.files) {
            vm.product.metadataFile = vm.product.metadataFile?.files[0]?.flowObj.files[0];
        }

        vm.saveStep(product, keys);
        setSourceMetadataEntityTabs();
    }
}